import { render } from "./VerovioComponent.vue?vue&type=template&id=6d292300"
import script from "./VerovioComponent.vue?vue&type=script&lang=js"
export * from "./VerovioComponent.vue?vue&type=script&lang=js"

import "./VerovioComponent.vue?vue&type=style&index=0&id=6d292300&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__